// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__S_iLs","border":"tabs_border__kqLfp","active":"tabs_active__0ZFBA"};